import React from 'react'
import BertholdTitle from 'src/components/atoms/bertholdTitle'
import { generateRandomId } from 'src/utils/domHelper'
import * as Styles from './headline.module.scss'

export type HeadlineContent = {
  anchor?: string
  headline?: string
}

type Props = {
  content: HeadlineContent
}

const Headline = ({ content }: Props) => {
  const { anchor = generateRandomId(), headline = '' } = content

  return (
    <section id={anchor} className={Styles.headlineSection}>
      <h2 className={Styles.headline}>{BertholdTitle({ text: headline })}</h2>
    </section>
  )
}

export default Headline
